// An empty previous period has no meaningful percentage, whatever the current value, so it is
// `none`, never "+100%" or "0%".
export type PeriodChange =
  | { kind: 'none' }
  | { kind: 'up' | 'down' | 'flat'; percent: number };

export function periodChange(current: number, previous: number): PeriodChange {
  if (!previous) return { kind: 'none' };
  const percent = ((current - previous) * 100) / previous;
  return {
    kind: percent > 0 ? 'up' : percent < 0 ? 'down' : 'flat',
    percent: Math.abs(percent),
  };
}
